module.exports = "/assets/data/fc846d033f626575dec5c1b1036f3c7f-DL7.data.json";